import { CalendarTodayOutlined } from '@material-ui/icons';
import { LeadBooking } from 'lib/generated/graphql';
import moment from 'moment-timezone';
import { useRef } from 'react';
import BookingModal from 'src/screens/book/components/BookingModal';
import useAuth from '../Auth';

const BookingCard = ({ booking }: { booking: LeadBooking }) => {
  const DEFAULT_USER_AVATAR = process.env.DEFAULT_USER_AVATAR || '';
  const DEFAULT_COMPANY_AVATAR = process.env.DEFAULT_COMPANY_AVATAR || '';
  const bookingModalRef = useRef<any>();
  const openCalendly = () => bookingModalRef.current.open();
  const { user } = useAuth();

  return (
    <div className="p-4 rounded-lg bg-white drop-shadow">
      <div className="">
        <div className="flex flex-row mt-5">
          <div className="flex grow ml-4">
            <div className="flex justify-center items-center mr-5 ">
              <div className="shadow-sm border-[5px] w-[63px] h-[63px] transform -rotate-12 flex justify-center items-center flex-shrink-0 shadow-[0px 14px 29px 0px bg-[#ffffff] border-[#fafafaca] rounded-[20px] z-[1] relative overflow-hidden">
                <img
                  src={'https://huddleworks.s3.amazonaws.com/48de2eca-28cf-4634-9fb5-8867e6f83d6c'}
                  className={`object-cover w-full ${DEFAULT_USER_AVATAR ? 'h-full' : 'h-[120%]'}`}
                />
              </div>

              <div className="-ml-6 shadow-md border-[5px] w-[63px] h-[63px] rotate-12 -mt-6 flex justify-center items-center flex-shrink-0 shadow-[0px 14px 29px 0px bg-[#EBB76A] border-[#FCE1B9] rounded-[20px]">
                <img src={'/images/customer-photo-url.svg'} className="w-[48px] h-[48px]" />
              </div>
            </div>
            <div>
              <p className="text-xl">1 hour with {booking.builder.name}</p> {/* Display name */}
              <p className="text-sm text-gray-500"> ${booking.builder.builderOnboarding.minimumRate} • Paid</p>{' '}
              {/* Display username */}
              {/* Display username */}
            </div>
          </div>

          <div>
            <div className="flex flex-row">
              <CalendarTodayOutlined fontSize="inherit" className="text-[#EBB76A]" aria-hidden="true" />
              <p className="text-sm text-gray-500 text-[#6B431A] ml-1">
                {moment(booking.date).tz('America/New_York').format('ddd, MMMM Do, YYYY hh:mm A zz')}
              </p>{' '}
            </div>
            <div className="">
              <button
                onClick={openCalendly}
                className={`w-full rounded-md px-6 py-2.5 font-small font-bold rounded-lg bg-[#D7D1E2] text-[#23241F] cursor-default mt-5`}
              >
                {'Book Again'}
              </button>
            </div>
          </div>
        </div>
        <div>
          <p className="text-md mt-4"></p> {/* Display name */}
        </div>
      </div>
      <BookingModal modalRef={bookingModalRef} lead={booking.builder} user={user} />
    </div>
  );
};

export default BookingCard;
